import React from 'react'
import i18n from '../../translations/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

let OrderPrice = props => {
	let {totalPrice, calculatedPrice, lng} = props;

	if (props.form !== undefined) {
		if (props.price==="Unavailable") {
			calculatedPrice = i18n.t('sidecard.price_unavailable', {lng})
		}
	}

	let showCurrency = (props.price==="Unavailable") ? false: true
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"

	if (props.priceRefresh===1) {
		return (
			<div className="text-center">
				<FontAwesomeIcon icon={faSpinner} color="#0D3680" size="xs" spin/>
			</div>
		)
	} else if (showCurrency) {
		return (
			<div>
				<div className="price-display">
					<h4><strong>{calculatedPrice} <sup>{currencySign} </sup></strong>{i18n.t('sidecard.wihout_tax', {lng})}</h4>
				</div>
				<div className="price-display">
					<h5>{totalPrice} <sup>{currencySign}</sup> {i18n.t('sidecard.tax_included', {lng})}</h5>
				</div>
			</div>
		)
	} else {
		return (
			<div className="price-display">
				<h4><strong>{calculatedPrice}</strong></h4>
			</div>
		)
	}
	
}

let MobileFooter = props => {
		return (
			<div className="pt-4">
			<OrderPrice
				currency={props.currency}
				price={props.price}
				lng={props.lng}
				priceRefresh={props.priceRefresh}
				page={props.page}
				billingCountry={props.billingCountry}
				service={props.service}
				form={props.form}
				totalPrice={props.totalPrice}
				calculatedPrice={props.calculatedPrice}
			/>
			</div>
		)
}
export default MobileFooter


// WEBPACK FOOTER //
// ./src/components/common/mobileFooter.js